import { render, staticRenderFns } from "./ModalLicenseAuthEducation.vue?vue&type=template&id=ba878092&scoped=true&"
import script from "./ModalLicenseAuthEducation.vue?vue&type=script&lang=js&"
export * from "./ModalLicenseAuthEducation.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicenseAuthEducation.vue?vue&type=style&index=0&id=ba878092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba878092",
  null
  
)

export default component.exports